// components/FieldCard.tsx
import React from 'react';
import { Box, Card, Group, Text, Badge, ActionIcon, Tooltip } from '@mantine/core';
import { IconEdit, IconTrash, IconArrowUp, IconArrowDown } from '@tabler/icons-react';
import { BuilderField, FIELD_TYPES } from '../types/BuilderField';

export interface FieldCardProps {
  field: BuilderField;
  span: number;
  readonly?: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onMove: (dir: -1 | 1) => void;
}

export function FieldCard({ field, span, readonly, onEdit, onDelete, onMove }: FieldCardProps) {
  const typeName = FIELD_TYPES.find((t) => t.code === field.fieldType)?.name ?? field.fieldType;

  return (
    <Box style={{ gridColumn: `span ${span}` }}>
      <Card withBorder padding="sm" radius="md">
        <Group justify="space-between" align="flex-start" wrap="nowrap">
          <Box style={{ minWidth: 0 }}>
            <Group gap="xs" wrap="nowrap">
              <Text fw={500} size="sm" truncate>{field.label}</Text>
              <Badge size="xs" variant="light" radius="sm">
                {typeName}
              </Badge>
              {!field.active && <Badge size="xs" color="gray">Inactive</Badge>}
            </Group>
            <Text size="xs" c="dimmed">
              {field.required ? 'Required' : 'Optional'} • Order {field.orderNo} • {field.fieldKey}
            </Text>
          </Box>
          {!readonly && (
            <Group gap={4} wrap="nowrap">
              <Tooltip label="Move up">
                <ActionIcon variant="subtle" size="sm" onClick={() => onMove(-1)}>
                  <IconArrowUp size={14} />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Move down">
                <ActionIcon variant="subtle" size="sm" onClick={() => onMove(1)}>
                  <IconArrowDown size={14} />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Edit">
                <ActionIcon variant="subtle" size="sm" onClick={onEdit}>
                  <IconEdit size={14} />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Delete">
                <ActionIcon variant="subtle" color="red" size="sm" onClick={onDelete}>
                  <IconTrash size={14} />
                </ActionIcon>
              </Tooltip>
            </Group>
          )}
        </Group>
      </Card>
    </Box>
  );
}